import {
  IconWrapper,
  IStyles,
  PrimaryButton,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { HalfCirclePopupBase } from './HalfCirclePopupBase';
import { Box, Typography } from '@mui/material';

const styles: IStyles = {
  popupBodyRoot: {
    marginTop: { xs: pxToRem(50), md: pxToRem(85) },
    marginBottom: { xs: pxToRem(20), md: pxToRem(35) },
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxToRem(30) },
    paddingX: { xs: pxToRem(20), md: pxToRem(15), lg: pxToRem(35) },
  },
  popupBodyTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxToRem(20) },
    width: 'max-content',
    margin: 'auto',
  },
  popupBodyButton: {
    width: { xs: 'max-content', md: 'max-content' },
    minWidth: { xs: '50%', md: pxTovW(444) },
    maxWidth: { xs: '90%', md: 'unset' },
    margin: 'auto',
    marginTop: { xs: pxToRem(10), md: pxToRem(10) },
  },
};

interface IProps {
  showFullScreenPopup: boolean;
  setShowFullScreenPopup: (show: boolean) => void;
  enterFullScreenMode: () => void;
  showTabSwitchPopup: boolean;
  setShowTabSwitchPopup: (show: boolean) => void;
  enterTabSwitchMode: () => void;
  showMultipleSessionPopup: boolean;
  setShowMultipleSessionPopup: (show: boolean) => void;
  enterMultipleSessionMode: () => void;
  showInactiveSessionPopup: boolean;
  setShowInactiveSessionPopup: (show: boolean) => void;
  enterInactiveSessionMode: () => void;
}
export const ProctoringPopups = (props: IProps) => {
  const {
    showFullScreenPopup,
    setShowFullScreenPopup,
    enterFullScreenMode,
    showTabSwitchPopup,
    setShowTabSwitchPopup,
    enterTabSwitchMode,
    showMultipleSessionPopup,
    setShowMultipleSessionPopup,
    enterMultipleSessionMode,
    showInactiveSessionPopup,
    setShowInactiveSessionPopup,
    enterInactiveSessionMode,
  } = props;

  // -------------------------------------------------------------

  return (
    <>
      {/* FULL SCREEN POPUP */}

      <HalfCirclePopupBase
        open={showFullScreenPopup}
        // handleClose={() => setShowFullScreenPopup(false)}
        handleClose={() => {}}
        iconName="full-screen-blue"
        // closeIcon
        popupBody={
          <Box sx={styles.popupBodyRoot}>
            <Box sx={styles.popupBodyTitle}>
              <IconWrapper
                name="error_yellow"
                size="md"
                parentFolder="icons"
                type="png"
              />
              <Typography variant="h2" color="primary.main" fontWeight="medium">
                Kindly Use Fullscreen Mode
              </Typography>
            </Box>

            <Typography variant="bodyText">
              This assessment can only be attended in
              <strong> full screen mode</strong> to
              <strong> prevent any suspicious activity</strong>.
            </Typography>

            <Typography variant="bodyText">
              Kindly<strong> return to fullscreen</strong> to resume the
              assessment
            </Typography>

            <PrimaryButton
              onClick={enterFullScreenMode}
              sx={styles.popupBodyButton}
            >
              <Typography variant="h3" fontWeight="bold" color="common.white">
                ENTER FULLSCREEN MODE
              </Typography>
            </PrimaryButton>
          </Box>
        }
      />

      {/* ------------------------------------------------------------- */}

      {/* TAB SWITCH POPUP */}

      <HalfCirclePopupBase
        open={showTabSwitchPopup}
        handleClose={() => setShowTabSwitchPopup(false)}
        iconName="dual-browsers"
        closeIcon
        popupBody={
          <Box sx={styles.popupBodyRoot}>
            <Box sx={styles.popupBodyTitle}>
              <IconWrapper
                name="error_yellow"
                size="md"
                parentFolder="icons"
                type="png"
              />
              <Typography variant="h2" color="primary.main" fontWeight="medium">
                Avoid Switching Tabs
              </Typography>
            </Box>

            <Typography variant="bodyText">
              <strong>Switching tabs </strong>during the test can be considered
              as<strong> suspicious activity</strong>.
            </Typography>

            <Typography variant="bodyText">
              Please refrain from doing rest of the assessment.
            </Typography>

            <PrimaryButton
              onClick={enterTabSwitchMode}
              sx={styles.popupBodyButton}
            >
              <Typography variant="h3" fontWeight="bold" color="common.white">
                OK, I UNDERSTAND
              </Typography>
            </PrimaryButton>
          </Box>
        }
      />

      {/* ------------------------------------------------------------- */}

      {/* INACTIVE SESSION POPUP */}

      <HalfCirclePopupBase
        open={showInactiveSessionPopup}
        handleClose={() => setShowInactiveSessionPopup(false)}
        iconName="social-pen"
        closeIcon
        popupBody={
          <Box sx={styles.popupBodyRoot}>
            <Box sx={styles.popupBodyTitle}>
              <IconWrapper
                name="error_yellow"
                size="md"
                parentFolder="icons"
                type="png"
              />
              <Typography variant="h2" color="primary.main" fontWeight="medium">
                Idle for Too Long
              </Typography>
            </Box>

            <Typography variant="bodyText">
              You’ve been<strong> inactive for a while</strong>.<br />
              For exam security, your session is about to expire.
            </Typography>

            <Typography variant="bodyText">
              Please <strong>interact with the page </strong>to continue.
            </Typography>

            <PrimaryButton
              onClick={enterInactiveSessionMode}
              sx={styles.popupBodyButton}
            >
              <Typography variant="h3" fontWeight="bold" color="common.white">
                CONTINUE
              </Typography>
            </PrimaryButton>
          </Box>
        }
      />

      {/* ------------------------------------------------------------- */}

      {/* MULTIPLE SESSION POPUP */}

      <HalfCirclePopupBase
        open={showMultipleSessionPopup}
        handleClose={() => setShowMultipleSessionPopup(false)}
        iconName="qr-code-scan"
        closeIcon
        popupBody={
          <Box sx={styles.popupBodyRoot}>
            <Box sx={styles.popupBodyTitle}>
              <IconWrapper
                name="error_yellow"
                size="md"
                parentFolder="icons"
                type="png"
              />
              <Typography variant="h2" color="primary.main" fontWeight="medium">
                Multiple Sessions Detected
              </Typography>
            </Box>

            <Typography variant="bodyText">
              You’re<strong> already logged in elsewhere. </strong>
              <br />
              For exam security,<strong> only one session </strong>is allowed.
            </Typography>

            <Typography variant="bodyText">
              <strong>Close other active windows </strong>or devices and refresh
              this page to continue.
            </Typography>

            <PrimaryButton
              onClick={enterMultipleSessionMode}
              sx={styles.popupBodyButton}
            >
              <Typography variant="h3" fontWeight="bold" color="common.white">
                OK
              </Typography>
            </PrimaryButton>
          </Box>
        }
      />
    </>
  );
};
